module.exports = __webpack_public_path__ + "static/Baba-Ganoush-75360fb546a85a99ddd17921888ec33e.png";